import { render } from "./TablePagination.vue?vue&type=template&id=0bfbbd1d&ts=true"
import script from "./TablePagination.vue?vue&type=script&lang=ts"
export * from "./TablePagination.vue?vue&type=script&lang=ts"

import "./TablePagination.vue?vue&type=style&index=0&id=0bfbbd1d&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__